import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { params, shape, string as stringType, QueryProvider } from '@thd-nucleus/data-sources';
import CheckBalanceForm from './check-balance/CheckBalanceForm';
import ReloadForm from './reload/ReloadForm';
import { getReCaptchaKey } from '../utils/utils';

const GiftCardsCheckBalanceAndReload = ({ isDrawer }) => {
  const [cardDetail, setCardDetail] = useState(null);
  const siteKey = getReCaptchaKey();
  const [errorMsg, setErrorMsg] = useState(false);

  const onError = (msg) => {
    setErrorMsg(msg);
  };

  useEffect(() => {
    if (window && window.sessionStorage.getItem('reloadCheckout')) {
      window.sessionStorage.removeItem('reloadCheckout');
    }
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('gift-cards-check-balance-and-reload.ready');
  }, []);

  const handleBalanceFormSubmit = (cardInfo) => {
    const {
      __typename,
      cardNumber,
      availableAmount,
      holdAmount,
      originalAmount,
      reloadableAmount
    } = cardInfo;
    const parsedCardInfo = {
      __typename,
      cardNumber,
      availableAmount: parseFloat(availableAmount),
      holdAmount: parseFloat(holdAmount),
      originalAmount: parseFloat(originalAmount),
      reloadableAmount: parseFloat(reloadableAmount)
    };
    setCardDetail(parsedCardInfo);
  };

  const handleCancel = () => {
    setCardDetail(null);
    onError('');
  };

  return (
    <QueryProvider
      cacheKey="gift-cards-check-balance-and-reload"
      defaultVariables={{
        itemId: '',
        dataSource: 'catalog'
      }}
    >
      <div
        className="g-recaptcha"
        data-sitekey={siteKey}
        data-size="invisible"
      />
      <div className="sui-w-full sui-h-full" data-component="GiftCardsCheckBalanceAndReload">
        {!cardDetail ? (
          <CheckBalanceForm
            errorMsg={errorMsg}
            onError={onError}
            onSubmit={handleBalanceFormSubmit}
            isDrawer={isDrawer}
          />
        ) : (
          <ReloadForm
            cardNumber={cardDetail?.cardNumber}
            reloadableAmount={cardDetail?.reloadableAmount}
            availableAmount={parseFloat(cardDetail?.availableAmount)}
            holdAmount={parseFloat(cardDetail?.holdAmount)}
            onCancel={handleCancel}
            isDrawer={isDrawer}
            errorMsg={errorMsg}
            onError={onError}
          />
        )}
      </div>
    </QueryProvider>
  );
};

GiftCardsCheckBalanceAndReload.displayName = 'GiftCardsCheckBalanceAndReload';
GiftCardsCheckBalanceAndReload.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType()
    })
  })
};

GiftCardsCheckBalanceAndReload.propTypes = {
  isDrawer: PropTypes.bool
};
GiftCardsCheckBalanceAndReload.defaultProps = {
  isDrawer: false
};

export { GiftCardsCheckBalanceAndReload };
